import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumericValidation]'
})
export class NumericValidationDirective {

  constructor() {

  }
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
    const isNumber = (event.key >= '0' && event.key <= '9');

    if (!isNumber && allowedKeys.indexOf(event.key) === -1) {
      event.preventDefault();
    }
  }
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(clipboardData)) {
      event.preventDefault();
    }
  }
}
